import '@fortawesome/fontawesome-free/css/all.min.css';
import '@govbr-ds/core/dist/core.min.css';
import * as Sentry from '@sentry/react';
import { AuthProvider } from 'hooks/useAuth';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import App from './App';
import { environment } from './environments/environment';
import './index.scss';
import reportWebVitals from './reportWebVitals';

const APP_SYSTEM_PATH = '/arrecadacao';

const GOOGLE_ANALYTICS_IDS: Record<string, string> = {
  pro: 'G-9E44DZLBBM',
};

const loadGoogleAnalytics = (): void => {
  const analyticsId = GOOGLE_ANALYTICS_IDS[environment.environment];
  if (!analyticsId) return;

  const gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
  document.head.appendChild(gtagScript);

  const inlineScript = document.createElement('script');
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${analyticsId}');
  `;
  document.head.appendChild(inlineScript);
};

loadGoogleAnalytics();

Sentry.init({
  dsn: 'https://6ff887feebfb4c5f94a730eec0f2af4d@sentry.aic.serpro.gov.br/1076',
  environment: environment.environment,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter basename={APP_SYSTEM_PATH}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);

reportWebVitals();
